import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Actempotravelleronrent() {



  const cardData =
  {
    keyword: 'Ac Tempo Traveller On Rent in Pune',
    heading: 'Sanavi Travels: Ac Tempo Traveller On Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable AC Tempo Traveller On Rent in Pune, providing safe, comfortable, and premium transportation solutions for families, corporate teams, wedding guests, tourists, and group travelers for both local and outstation trips. Our fleet of AC tempo travellers with 9, 12, 13, 14, 17, and 26 seating capacities is well-maintained and equipped with push-back leather seats, powerful air-conditioning, ample legroom, charging points, music systems, and generous luggage space, ensuring a luxurious travel experience. With experienced and licensed chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual service and smooth journeys. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Konkan, and other popular routes. Choose Sanavi Travels for trusted AC tempo traveller rental services in Pune, delivering comfort, safety, and a premium group travel experience.',

    top: 'Top Places to Visit in Pune  with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a symbol of Maratha pride. Once the seat of Peshwa Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and well-laid gardens. Despite being partially destroyed by fire, the ruins still echo royal grandeur. The evening light-and-sound show brings Maratha history to life, making Shaniwar Wada the cultural and historical heart of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a landmark deeply connected to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying photographs, personal belongings, and historical documents. The palace’s sprawling gardens and Italian-style architecture create a serene ambiance. Aga Khan Palace is a symbol of sacrifice, peace, and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual site, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations, music, and cultural events. The temple trust is also known for extensive charitable work. Dagdusheth Ganpati represents the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the heroic sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Situated atop a rugged hill, the fort offers panoramic views of the Sahyadri ranges. Visitors can trek or drive up to explore ancient gates, memorials, and viewpoints. Sinhagad combines history, adventure, and natural beauty, making it a favorite among tourists and trekkers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Located in the busy city center, it offers a calm and meditative atmosphere. Monolithic pillars and ancient carvings showcase early Indian architectural excellence. Pataleshwar is a hidden heritage retreat offering spiritual solace in Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s cultural and artistic heritage. The collection includes musical instruments, traditional household items, sculptures, and ornaments. The recreated Mastani Mahal is a highlight. The museum is a must-visit for art, history, and culture enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering stunning panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex, built during the Peshwa era. Smaller shrines and a museum enhance its cultural appeal. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. The serene environment promotes relaxation and personal growth. Osho Ashram is Pune’s international center for spiritual and holistic wellness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns create a tranquil environment. Families, joggers, and photography enthusiasts enjoy leisurely walks. The garden blends Japanese aesthetics with Indian nature, offering a peaceful sanctuary in the urban landscape."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune, especially during monsoon. The reservoir and surrounding hills offer scenic views, while street vendors provide local snacks and refreshments. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is ideal for weekend getaways, sunset views, and family outings."
  }
]
,




"services": [
  {
    "name": "Ac Tempo Traveller On Rent in Pune",
    "description": "Ac Tempo Traveller On Rent in Pune provides comfortable and reliable air-conditioned vehicles for group travel. Ideal for family trips, corporate travel, or outstation journeys, these well-maintained tempo travellers offer spacious seating, ample luggage space, and professional drivers to ensure a safe and pleasant journey."
  },
  {
    "name": "AC Tempo Traveller Hire Pune",
    "description": "AC Tempo Traveller Hire Pune offers flexible rental services for air-conditioned tempo travellers. Perfect for sightseeing, weekend getaways, or corporate travel, these vehicles ensure comfort, punctuality, and convenience for passengers traveling within Pune or to nearby destinations."
  },
  {
    "name": "Air Conditioned Tempo Traveller Pune",
    "description": "Air Conditioned Tempo Traveller Pune provides well-equipped AC vehicles for long-distance travel. With comfortable seating, ample luggage capacity, and experienced chauffeurs, this service ensures a relaxed and stress-free journey for families, friends, or business groups."
  },
  {
    "name": "Luxury AC Tempo Traveller Pune",
    "description": "Luxury AC Tempo Traveller Pune offers premium vehicles with enhanced comfort features for a stylish travel experience. Equipped with reclining seats, entertainment options, and spacious interiors, it is perfect for VIP trips, weddings, or corporate travel, ensuring a luxurious and enjoyable ride."
  },
  {
    "name": "Family AC Tempo Traveller Pune",
    "description": "Family AC Tempo Traveller Pune ensures safe and comfortable travel for families. With spacious seating, child-friendly interiors, and professional drivers, it provides a convenient and enjoyable travel experience for family outings, vacations, or weekend trips."
  },
  {
    "name": "Corporate AC Tempo Traveller Pune",
    "description": "Corporate AC Tempo Traveller Pune caters to business and office groups, offering air-conditioned vehicles with spacious seating and amenities suitable for work or relaxation during travel. Experienced chauffeurs ensure timely and safe transfers for corporate trips or meetings."
  },
  {
    "name": "Outstation AC Tempo Traveller Pune",
    "description": "Outstation AC Tempo Traveller Pune provides comfortable and reliable AC vehicles for long-distance journeys. Ideal for outstation travel, sightseeing tours, or weekend getaways, these tempo travellers ensure safety, punctuality, and convenience for all passengers."
  },
  {
    "name": "Affordable AC Tempo Traveller Pune",
    "description": "Affordable AC Tempo Traveller Pune offers budget-friendly options for air-conditioned group travel without compromising on comfort or safety. Well-maintained vehicles and professional drivers make it perfect for families, friends, or corporate travelers looking for economical transport."
  },
  {
    "name": "Chauffeur Driven AC Tempo Traveller",
    "description": "Chauffeur Driven AC Tempo Traveller provides professional drivers to handle routes and traffic, allowing passengers to relax throughout their journey. Spacious and comfortable, this service ensures a stress-free, safe, and enjoyable travel experience."
  },
  {
    "name": "Group Travel AC Tempo Traveller Pune",
    "description": "Group Travel AC Tempo Traveller Pune caters to large groups seeking air-conditioned transport. With ample seating, luggage space, and experienced drivers, it is ideal for corporate outings, school trips, or friends traveling together."
  },
  {
    "name": "Best AC Tempo Traveller Pune",
    "description": "Best AC Tempo Traveller Pune offers top-quality vehicles and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a smooth, safe, and enjoyable journey."
  },
  {
    "name": "Pune AC Tempo Traveller Booking",
    "description": "Pune AC Tempo Traveller Booking provides hassle-free reservations for air-conditioned tempo travellers in Pune. Flexible booking options, reliable vehicles, and professional chauffeurs ensure a convenient and comfortable travel experience."
  },
  {
    "name": "Tourist AC Tempo Traveller Pune",
    "description": "Tourist AC Tempo Traveller Pune is designed for sightseeing and travel within Pune or nearby tourist destinations. Spacious AC vehicles, comfortable seating, and experienced drivers make it ideal for tourists exploring the city or planning weekend trips."
  },
  {
    "name": "Wedding AC Tempo Traveller Pune",
    "description": "Wedding AC Tempo Traveller Pune offers luxurious air-conditioned vehicles for wedding events, ensuring comfortable and stylish transport for family and guests. Professional chauffeurs, ample seating, and luggage space make wedding travel smooth and convenient."
  },
  {
    "name": "Airport Transfer AC Tempo Traveller",
    "description": "Airport Transfer AC Tempo Traveller provides timely and comfortable transfers to Pune airport or from the airport. Spacious air-conditioned vehicles and professional drivers ensure a stress-free journey for families, friends, or corporate travelers."
  }
],
"tableData": [
  ["Ac Tempo Traveller On Rent in Pune", "AC Tempo Traveller Hire Pune"],
  ["Air Conditioned Tempo Traveller Pune", "Luxury AC Tempo Traveller Pune"],
  ["Family AC Tempo Traveller Pune", "Corporate AC Tempo Traveller Pune"],
  ["Outstation AC Tempo Traveller Pune", "Affordable AC Tempo Traveller Pune"],
  ["Chauffeur Driven AC Tempo Traveller", "Group Travel AC Tempo Traveller Pune"],
  ["Best AC Tempo Traveller Pune", "Pune AC Tempo Traveller Booking"],
  ["Tourist AC Tempo Traveller Pune", "Wedding AC Tempo Traveller Pune"],
  ["Airport Transfer AC Tempo Traveller", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "AC Tempo Traveller On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable AC Tempo Traveller rental services in Pune, perfect for family trips, group outings, corporate travel, and outstation journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained AC Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced AC Tempo Travellers designed for a smooth and relaxing journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, professional, and familiar with Pune and nearby routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for AC Tempo Traveller rentals in Pune, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, travel inquiries, and schedule changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, one-way, round-trip, or customized AC Tempo Traveller rental plans to suit your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All AC Tempo Travellers are cleaned and thoroughly sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for AC Tempo Traveller rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide AC Tempo Traveller on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers well-maintained and comfortable AC Tempo Travellers for rental in Pune.'
  },
  {
    question: 'How can I book an AC Tempo Traveller in Pune with Sanavi Travels?',
    answer: 'You can easily book through our website or by contacting our 24×7 customer support team.'
  },
  {
    question: 'What seating capacities are available for AC Tempo Traveller rentals?',
    answer: 'We offer AC Tempo Travellers in various seating options including 9-seater, 12-seater, 13-seater, 17-seater, and more.'
  },
  {
    question: 'Are drivers included with the AC Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the AC Tempo Traveller service available 24×7?',
    answer: 'Yes, our AC Tempo Traveller rental service is available round the clock to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before every trip?',
    answer: 'Yes, all AC Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the AC Tempo Traveller rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans based on your travel requirements.'
  },
  {
    question: 'What payment options are available for AC Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24×7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash More',
    feedback: 'Booked an AC Tempo Traveller from Sanavi Travels in Pune. Very comfortable, clean, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Great experience! The AC Tempo Traveller was spacious, on-time, and the driver was very professional.',
    rating: 5
  }
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Tempo Traveller On Rent in Pune - Sanavi Travels",
  "description": "Hire AC Tempo Traveller on rent in Pune with Sanavi Travels. Air-conditioned and luxury tempo travellers for family trips, corporate travel, outstation journeys, weddings, airport transfers, tourist travel, and group transportation with chauffeur-driven comfort.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>

<Helmet>
  <title>
    AC Tempo Traveller On Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC Tempo Travellers on rent in Pune with Sanavi Travels. Ideal for family travel, corporate trips, outstation tours, weddings, airport transfers, tourist travel, and comfortable group journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Actempotravelleronrent;